var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    {
      staticClass: "btn btn-gold w-100 cursor-pointer",
      attrs: { to: { name: "premium" } }
    },
    [
      _c("span", [
        _vm._v(_vm._s(_vm.translate.account.lockedProfile.upgradeToGold))
      ]),
      _vm._v(" "),
      _c("icon-component", {
        staticClass: "ml-2 h-100 upgrade-gold-icon",
        attrs: { icon: _vm.fa_stars_regular() }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-338b2d76", { render: render, staticRenderFns: staticRenderFns })
  }
}